import { FC } from 'react';
import { FormBehavior, observer, useLocation, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { PAYMENT_TYPE, useStores } from '~/utils';
import CreditSimulationPixKeyConfirmation from './CreditSimulationPixKeyConfirmation';
import {
  type CreditSimulationPixKeyConfirmationFormValues,
  initialValues,
  validationSchema,
} from './schema';

const CreditSimulationPixKeyConfirmationContainerContainer: FC = () => {
  const { creditProducts } = useStores();
  const location = useLocation();
  const navigate = useNavigate();
  const pixKey = location.state?.pixKey || '';

  const onSubmit = async (
    values: CreditSimulationPixKeyConfirmationFormValues,
  ) => {
    creditProducts.setCurrentCreditSimulationRequest({
      pixKey: values.CreditSimulationPixKeyConfirmation,
      paymentType: PAYMENT_TYPE.TRANSFER,
    });
    await creditProducts.creditSimulation();
    navigate(Routes.CREDIT_SIMULATION_CONFIRMATION);
  };
  return (
    <FormBehavior
      validationSchema={validationSchema(pixKey)}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <CreditSimulationPixKeyConfirmation />
    </FormBehavior>
  );
};
export default observer(CreditSimulationPixKeyConfirmationContainerContainer);
